module.exports = __webpack_public_path__ + "static/img/ic-prime-logo-white.fa4cea8f.svg";